export default "__VITE_PUBLIC_ASSET__d12f3211__"